import { decodeQueryParamValues } from '@aibees/shared/utils';

export const getFormattedValue = (encodedValue?: string): string => {
  if (!encodedValue) return '';
  const decodedValues = decodeQueryParamValues(encodedValue);
  return decodedValues.join(', ');
};
